export const Heading = `
    <Heading size="h2">
        Heading 2
    </Heading>
`
